import React from 'react';
import { Link } from 'react-router-dom';
import {
  Youtube,
  Twitter,
  MessageCircle,
  Shield,
  Zap
} from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-black/70 to-black/90 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Top Section with Logo and Social Icons */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <div className="mb-8 md:mb-0">
            <div className="flex items-center">
              <img 
                src="/logo.svg" 
                alt="VicoGambles Logo" 
                className="w-auto h-20 mr-2"
              />
            </div>
            <p className="text-gray-400 mt-2 text-sm max-w-md">
              Your ultimate destination for exclusive wager competitions, bonuses, and community rewards.
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://discord.gg/Peh7QBjP93"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#D7FF00]/10 hover:bg-[#D7FF00]/20 text-[#D7FF00] p-3 rounded-full transition-colors duration-300 inline-flex items-center justify-center"
              aria-label="Join our Discord server"
            >
              <FontAwesomeIcon icon={faDiscord} className="w-5 h-5" style={{ width: '1.25rem', height: '1.25rem' }} />
            </a>
            <a
              href="https://x.com/VicoGambles"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#D7FF00]/10 hover:bg-[#D7FF00]/20 text-[#D7FF00] p-3 rounded-full transition-colors duration-300 inline-flex items-center justify-center"
              aria-label="Follow us on Twitter"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="https://www.youtube.com/@VicoGambles"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#D7FF00]/10 hover:bg-[#D7FF00]/20 text-[#D7FF00] p-3 rounded-full transition-colors duration-300 inline-flex items-center justify-center"
              aria-label="Subscribe to our YouTube channel"
            >
              <Youtube className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Responsible Gambling Notice */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <div className="bg-white/5 p-4 rounded-lg">
            <div className="flex items-start">
              <Shield className="w-5 h-5 text-[#D7FF00] mr-3 mt-0.5 flex-shrink-0" />
              <p className="text-gray-400 text-sm">
                <span className="font-semibold text-white">Gamble Responsibly (18+):</span> Do not think of gambling as a way to make money; only gamble for fun and enjoyment with money you can afford to lose. We do not take responsibility for any losses from gambling in casinos and betting sites which are linked or promoted on our website(s).
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Goated Leaderboard. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;